const buffer = new URL('../../icons/buffer.png', import.meta.url).href

export default {
  type: 'Buffer',
  description: 'Buffer',
  icon: buffer,
  group: 'BCS',
  model: {
    type: 'Buffer',
    left: 100,
    top: 100,
    width: 30,
    height: 30
  }
}
